/* eslint-disable no-mixed-spaces-and-tabs */
import { useState, useEffect } from 'react'
import Image from 'next/image'
import { allergensList } from '@/lib/utils/allergensPath'
import { Currency, ITheme, Language } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'
import OrderingWidget from './ordering/OrderingWidget'

interface DetailedPopUpProps {
	setShowFullItem: (show: boolean) => void
	name: string
	description?: string
	detailText?: string
	imageSource?: string | null
	allergens?: string[]
	price?: number | string
	halfprice?: number | string
	tapaprice?: number | string
	fourthprice?: number | string
	allergenImages: string[] | undefined
	isFood?: boolean
	theme: ITheme
  language: Language
	fontStyle: {
		fontFamily: NextFont
		fontSize: string
	},
  currency: Currency
  orderingActive: boolean
  itemId: string
}

const DetailedPopUp = ({
  setShowFullItem,
  name,
  description,
  detailText,
  imageSource,
  allergens,
  price,
  halfprice,
  tapaprice,
  isFood,
  theme,
  fontStyle,
  currency,
  language,
  orderingActive,
  itemId
}: DetailedPopUpProps) => {
  const [isVisible, setIsVisible] = useState(true)

  const tapaText = language === 'es' ? 'Tapa' : 'Tapa'
  const halfText = language === 'es' ? 'Half' : 'Media'
  const fullText = language === 'es' ? 'Ration' : 'Ración'

  const priceStyle = { backgroundColor: theme.items.bgPriceColor, color: theme.items.priceTextColor }

  const handleClose = () => {
    setIsVisible(false)
  }

  // Función para cerrar el popup con animación, se pasa al OrderingWidget
  const closePopup = () => {
    setIsVisible(false)
  }

  useEffect(() => {
    if (!isVisible) {
      // Espera a que la animación termine antes de cerrar
      const timer = setTimeout(() => {
        setShowFullItem(false)
      }, 300) // Debe coincidir con la duración de la animación

      return () => clearTimeout(timer)
    }
  }, [isVisible, setShowFullItem])

  return (
    <div className={`overlay ${isVisible ? 'fade-in' : 'fade-out'}`} onClick={handleClose}>
      <div className={`detailed-item ${isVisible ? 'scale-up' : 'scale-down'}`} onClick={(e) => e.stopPropagation()}>
        {/* <X
          className='close-icon'
          style={{ backgroundColor: theme.items.bgPriceColor }}
          onClick={handleClose}
        /> */}

        {imageSource && (
          <Image src={imageSource} className={!orderingActive ? 'product-img' : 'product-img thin-image'} alt={`imagen de ${name}`} width={400} height={300} />
        )}

        <div className='detailed-item__info'>
          <h5 className={fontStyle.fontFamily.className}>{name}</h5>
          <p className={fontStyle.fontFamily.className}>{description}</p>
          <p className='detailed-text'>{detailText}</p>
          <div className='allergens-container center'>
            {allergens &&
							allergens.length > 0 &&
							allergens.map((allergen) => (
  <div
    key={allergen}
    data-allergen={language === 'es' ? allergensList[allergen].name_es : language === 'fr' ? allergensList[allergen].name_fr : allergensList[allergen].name_en}
    className='allergen__img-wrapper'
  >
    <Image
      className='allergen__img'
      width={40}
      height={40}
      src={allergensList[allergen].img}
      alt={allergen}
    />
  </div>
							))}
          </div>
          <div className='prices center'>
            {tapaprice !== 0 && (
              <span className={fontStyle.fontFamily.className} style={priceStyle}>
                {isFood
                  ? (
                    <span>
                      {tapaText} · {tapaprice}
                    </span>
                    )
                  : (
								  tapaprice
                    )}
                {currency}
              </span>
            )}
            {halfprice !== 0 && (
              <span className={fontStyle.fontFamily.className} style={priceStyle}>
                {isFood
                  ? (
                    <span>
                      {halfText} · {halfprice}
                    </span>
                    )
                  : (
								  halfprice
                    )}
                {currency}
              </span>
            )}
            {price !== 0 && (
              <span className={fontStyle.fontFamily.className} style={priceStyle}>
                {isFood
                  ? (
                    <span>
                      {fullText} · {price}
                    </span>
                    )
                  : (
								  price
                    )}
                {currency}
              </span>
            )}
          </div>
        </div>
        {orderingActive && (
          <>
            <hr style={{ width: '90%', border: 'none', borderTop: '1px solid #f2f2f2' }} />
            <OrderingWidget
              isVisible={isVisible}
              itemId={itemId}
              itemName={name}
              price={price}
              halfprice={halfprice}
              tapaprice={tapaprice}
              closePopup={closePopup}
              language={language}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default DetailedPopUp
